import { render, staticRenderFns } from "./ThirdPartyGames.vue?vue&type=template&id=266ad600&scoped=true"
import script from "./ThirdPartyGames.vue?vue&type=script&lang=js"
export * from "./ThirdPartyGames.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyGames.vue?vue&type=style&index=0&id=266ad600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ad600",
  null
  
)

export default component.exports